import classNames from 'classnames';
import React, { memo, useEffect, useState } from 'react';
import './index.less';

const SwitchTab = (props) => {
  const {
    onChange,
    initVal = {
      key: 'myShop',
      index: 1,
      name: '商品报名',
      localName: '商品报名',
    },
    tab,
    getTabData,
    showNum = true, //滑块展示数字
    small = true, //小号样式
    disabled = false, //组件禁用点击
  } = props;
  const [activeTab, setActiveTab] = useState(initVal);
  const [left, setLeft] = useState(getTabData()[0]?.left || 0);
  const [curEle, setCurEle] = useState(null);
  const [curCls] = useState(`ts-${Date.now()}`);
  const changeTab = (item, e) => {
    if (disabled) return;
    setActiveTab(item);
    setCurEle(e.currentTarget);
    onChange(item.key);
  };
  useEffect(() => {
    setActiveTab({ ...tab });
    const index = getTabData().findIndex((item) => item?.key === tab?.key);
    setCurEle(document.querySelectorAll(`.switch-tab-container.${curCls} .switch-tab .tab`)[index]);
  }, [tab]);

  useEffect(() => {
    const offsetLeft = curEle?.offsetLeft;
    const initLeft = getTabData()[0]?.left || 0;
    // setLeft(offsetLeft ? offsetLeft - initLeft : initLeft);
    setLeft(offsetLeft ? offsetLeft - initLeft : initLeft);
  }, [activeTab, curEle?.offsetLeft, getTabData]);

  return (
    <div className={`switch-tab-container ${curCls}`}>
      <div
        className={classNames({
          'switch-tab': true,
          'switch-tab-small': small,
          'switch-tab-disabled': disabled,
        })}
      >
        {getTabData().map((item, index) => (
          <React.Fragment key={item.key}>
            <div className="tab" onClick={(e) => changeTab(item, e)} clstag={item.clstag}>
              {showNum && <span className="index-num">{index + 1}</span>}
              <span className="tab-name">{item.localName || item.name}</span>
            </div>
          </React.Fragment>
        ))}
        {activeTab.key && (
          <div className="tab active-tab" style={{ left }}>
            {showNum && <span className="index-num">{activeTab.index}</span>}
            {activeTab.name}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(SwitchTab);
